import { useEffect } from 'react';
import { atom, useAtomValue, useSetAtom } from 'jotai';
import { useShouldShowTopBanner } from '@app/domain/user/hooks/useShouldShowTopBanner';
import { useActivePlan } from '@app/domain/plan/hooks/useActivePlan';
import { ETrialPhase, useTrialPhasesConfig } from '@app/domain/plan/hooks/useTrialPhasesConfig';

export const topBannerHeightAtom = atom<number>(0);
export const topBannerActiveAtom = atom<boolean>(false);

export const useTopBannerState = () => {
  const height = useAtomValue(topBannerHeightAtom);
  const isActive = useAtomValue(topBannerActiveAtom);
  const setIsActive = useSetAtom(topBannerActiveAtom);

  const shouldShowTopBanner = useShouldShowTopBanner();
  const { isTrial, isFreePlan } = useActivePlan();
  const { currentTrialPhase } = useTrialPhasesConfig();

  const showIfFreePlan = isFreePlan;
  const showIfTrialBunnerActive = isTrial && currentTrialPhase !== ETrialPhase.NONE;

  useEffect(() => {
    if (shouldShowTopBanner && (showIfFreePlan || showIfTrialBunnerActive)) {
      setIsActive(true);
      return;
    }
    setIsActive(false); // If no one is appointed
  }, [shouldShowTopBanner, showIfFreePlan, setIsActive, showIfTrialBunnerActive]);

  return { height, isActive, setIsActive, shouldShowTopBanner };
};
